import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
    Box,
      CardMedia,
  TextField,
    IconButton,
  Grid,
  FormControlLabel,
  Switch,
  Typography
} from "@mui/material";
import { Autocomplete, createFilterOptions } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik } from "formik";
import * as Yup from "yup";
import { myApi } from "../../../config/axiosConfig";

const TireModal = ({
  open,
  onClose,
  index,
  values,
  setFieldValue,
  label,
  setStepData,
  steps
}) => {
  const tire = values?.topTirePhotos?.[index] || {};

  const validationSchema = Yup.object().shape({
    //marca_id: Yup.string().required("Marca obligatoria"),
    marca_id: Yup.mixed().required("Marca obligatoria"),
    tipo_material: Yup.boolean().required("Tipo obligatorio"),
  });

  const [marcas, setMarcas] = useState([]);

  const [creatingBrand, setCreatingBrand] = useState(false);
  const filter = createFilterOptions();

  useEffect(() => {
    const loadMarcas = async () => {
      try {
        if (!open) return;
        const response = await myApi.get('/alta_unidad/marcas/llantas');
        setMarcas(response.data.marcas || response.data.data || []);
      } catch (error) {
        console.error("Error cargando marcas:", error);
      }
    };
    loadMarcas();
  }, [open]);

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle
        sx={{
          textTransform: 'uppercase',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '1.2rem',
          bgcolor: '#1976d2',
          px: 3,
          py: 2,
          mb: 2, // <-- Espacio debajo del título
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          borderBottom: '3px solid #115293',
          borderTopLeftRadius: '4px',
          borderTopRightRadius: '4px',
        }}
      >
        <span role="img" aria-label="llanta">🚛</span>
        Datos de la LLANTA {label}
      </DialogTitle>
      <Formik
        initialValues={{
          marca_id: tire.marca_id || "",
          tipo_material: tire.tipo_material ?? true,
          fotos: tire.fotos || [],
        }}
        validationSchema={validationSchema}
        onSubmit={(formData) => {
          const updatedPhotos = [...(values.topTirePhotos || [])];
          updatedPhotos[index] = {
            ...formData,
            label,
          };
          setFieldValue("topTirePhotos", updatedPhotos);
          setStepData(prev => {
            const updated = [...prev];
            const stepIndex = steps.findIndex(s => s.photoKey === "topTirePhotos");
            if (stepIndex >= 0) {
              const currentStep = updated[stepIndex] || {};
              updated[stepIndex] = {
                ...currentStep,
                topTirePhotos: updatedPhotos,
              };
            }
            return updated;
          });
          onClose();
        }}
      >
        {({
          values: localValues,
          handleSubmit,
          setFieldValue: setLocalFieldValue,
          errors,
          touched,
        }) => (
          <>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    options={marcas}
                    loading={creatingBrand}
                    //getOptionLabel={(option) => option.nombre}
                    getOptionLabel={(option) => {
                      // opción normal
                      if (option?.nombre) return option.nombre;
                      // opción "virtual" para crear
                      if (option?.inputValue) return option.inputValue;
                      return "";
                    }}
                    isOptionEqualToValue={(option, value) =>
                      String(option?.id) === String(value?.id)
                    }
                    //value={marcas.find(m => m.id === localValues.marca_id) || null}
                    value={
                      marcas.find(m => String(m.id) === String(localValues.marca_id)) || null
                    }
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      const inputValue = (params.inputValue || "").trim();

                      const exists = options.some(
                        (opt) => opt.nombre?.toLowerCase() === inputValue.toLowerCase()
                      );

                      if (inputValue !== "" && !exists) {
                        filtered.push({
                          id: "__new__",
                          inputValue,
                          nombre: `Agregar "${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
/*                     onChange={(_, newValue) => {
                      const newId = newValue?.id || "";
                      setLocalFieldValue("marca_id", newId);
                    }} */
                    onChange={async (_, newValue) => {
                      if (!newValue) {
                        setLocalFieldValue("marca_id", "");
                        return;
                      }

                      // Si eligió "Agregar ..."
                      if (newValue?.id === "__new__" && newValue?.inputValue) {
                        try {
                          setCreatingBrand(true);

                          const nombre = newValue.inputValue.trim();
                          const resp = await myApi.post('/alta_unidad/marcas/llantas', { nombre });

                          // tu backend debería regresar { success:true, marca:{id,nombre}, existed }
                          const marcaNueva = resp.data?.marca;

                          if (!marcaNueva?.id) {
                            throw new Error("No regresó marca válida");
                          }

                          setMarcas(prev => {
                            const already = prev.some(m => String(m.id) === String(marcaNueva.id));
                            return already ? prev : [...prev, marcaNueva].sort((a,b) =>
                              a.nombre.localeCompare(b.nombre)
                            );
                          });

                          setLocalFieldValue("marca_id", marcaNueva.id);
                        } catch (err) {
                          console.error("Error creando marca:", err);
                          // aquí puedes usar Swal si quieres:
                          // Swal.fire({ icon:'error', title:'Error', text:'No se pudo crear la marca' })
                        } finally {
                          setCreatingBrand(false);
                        }
                        return;
                      }

                      // selección normal
                      setLocalFieldValue("marca_id", newValue?.id || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Marca"
                        margin="dense"
                        fullWidth
                        error={touched.marca_id && Boolean(errors.marca_id)}
                        helperText={touched.marca_id && errors.marca_id}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box mt={1}>
                  <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                    Tipo de Rin
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={localValues.tipo_material}
                        onChange={(e) =>
                          setLocalFieldValue("tipo_material", e.target.checked)
                        }
                        name="tipo_material"
                        color="primary"
                      />
                    }
                    label={localValues.tipo_material ? "Metálico" : "Aluminio"}
                  />
                </Box>
                </Grid>
                {/* <Grid item xs={12}>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    capture="environment"
                    style={{ display: "none" }}
                    id="upload-multiple-photos"
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      const newFotos = files.map(file => ({
                        file,
                        url: URL.createObjectURL(file),
                      }));
                      setLocalFieldValue("fotos", [...localValues.fotos, ...newFotos]);
                      e.target.value = null;
                    }}
                  />
                  <label htmlFor="upload-multiple-photos">
                    <Button variant="outlined" component="span" fullWidth>
                      {(localValues.fotos?.length || 0) > 0 ? "Agregar más fotos" : "Subir fotos"}
                    </Button>
                  </label>
                </Grid> */}
                <Grid item xs={12}>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    id={`upload-photo-${index}`}
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      if (files.length > 0) {
                        const newFotos = files.map((file) => ({
                          file,
                          url: URL.createObjectURL(file),
                        }));

                        setLocalFieldValue("fotos", [
                          ...localValues.fotos,
                          ...newFotos,
                        ]);
                      }

                      // 👇 Esto es CLAVE para evitar problemas de iOS (no guarda si repites)
                      e.target.value = null;
                    }}
                  />
                  <label htmlFor={`upload-photo-${index}`}>
                    <Button
                      variant="outlined"
                      component="span"
                      fullWidth
                      color="primary"
                    >
                      Agregar foto
                    </Button>
                  </label>
                </Grid>

                {localValues.fotos.length > 0 && (
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      {localValues.fotos.map((foto, idx) => (
                        <Grid item xs={6} sm={4} key={idx}>
                          <Box position="relative">
                            <CardMedia
                              component="img"
                              height="140"
                              image={foto.url}
                              sx={{ borderRadius: 2 }}
                            />
                            <IconButton
                              onClick={() => {
                                const updated = [...localValues.fotos];
                                updated.splice(idx, 1);
                                setLocalFieldValue("fotos", updated);
                              }}
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                backgroundColor: "rgba(255,255,255,0.7)",
                              }}
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
              <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="success"
                  fullWidth
                  size="large"
                  sx={{ fontWeight: 'bold', py: 1.5, fontSize: '1rem' }}
                >
                  Guardar
              </Button>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default TireModal;
